// extracted by mini-css-extract-plugin
module.exports = {"modal-bonus":"modal-bonus_modal-bonus__-UnuU","icon":"modal-bonus_icon__2r7Ex","close":"modal-bonus_close__3akfL","loader":"modal-bonus_loader__zEBUo"};